//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// loader-clock imports
import { styles } from "./LoaderClock.styles";
// material-ui
import { WithStyles } from "@material-ui/core/styles/withStyles";
import withStyles from "@material-ui/core/styles/withStyles";

interface IProps extends WithStyles<typeof styles> {}

interface IState {}

//////////////////
// COMPONENT
//////////////////
class LoaderClockCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    return (
      <div className={this.props.classes.root}>
        <div className={this.props.classes.center}></div>
        <div className={this.props.classes.minute}></div>
        <div className={this.props.classes.hour}></div>
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const LoaderClock = withStyles(styles)(LoaderClockCmpt);
